'use client';

import { CommonHeading } from '~/components/flp/Financing.styles';
import Section from '~/components/flp/Section';
import { ANALYTICS_EVENTS } from '~/constants/flp/analyticsEvents';
import { useFinancingContext } from '~/context/flp/FinancingContext';
import CoSigner from './CoSigner';
import {
  Content,
  Controls,
  CustomizeYourDealSection
} from './CustomizeYourDeal.styles';
import TradeIn from './TradeIn';
import YourTerms from './YourTerms';

export default function CustomizeYourDeal() {
  const { coSigner, tradeIn } = useFinancingContext();
  const cardData = { coSigner, tradeIn };
  const cardsDisplayedCount =
    Object.values(cardData).filter(card => card !== null).length + 1;

  return (
    <Section
      as={CustomizeYourDealSection}
      eventName={ANALYTICS_EVENTS.PREQUALIFIED.SECTION_VIEWED_CUSTOMIZEYOURDEAL}
    >
      <Content>
        <CommonHeading>Ways to improve your buying experience</CommonHeading>
        <Controls showFourCards={cardsDisplayedCount === 4}>
          <YourTerms />
          <CoSigner />
          <TradeIn />
        </Controls>
      </Content>
    </Section>
  );
}
